//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Paper,
    Button as MaterialButton,
    IconButton,
    Select,
    MenuItem,
    Menu,
    InputLabel,
    FormControl,
    TextField,
    Chip,
    createTheme,
    ThemeProvider,
    Autocomplete,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    useMediaQuery,
    CircularProgress,
    useTheme,
    Tooltip,
    Stack,
    Checkbox
} from '@mui/material';
import { createBooleanOperator, DateTimePickerControl, InputControl, NumericFormatInputControl } from '../../molecules';
import { useGetMerchantAccountHistory, useGetMerchantsWithParentMerchant, useGetMerchantCurrentBalanceTypeSettingsList, useMerchantCurrentBalanceMovement, GetMerchantAccountHistoryListRequest, useGetMerchantWithLatestMovementDetail, PagingResponse, useAuthorization, useMerchantCurrentBalanceMovementUpdate, useMerchantCurrentBalanceMovementDelete, useConfirmationModal, useGetMerchantMonthlyTransactionAmount, GetMerchantMonthlyTransactionAmountRequest, useGetAllMerchantList, useGetCurrencyCodeList } from '../../../hooks';
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { Table } from '../../../components';
import {
    GridColDef,
    GridPaginationModel,
    GridValueFormatterParams,
} from "@mui/x-data-grid";
import dayjs from 'dayjs';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useLocation } from 'react-router-dom';
import { downloadExcel } from "../../../util/downloadExcel";
import { ViewSidebar, ViewSidebarOutlined } from '@mui/icons-material';
import { RequestFilterOperationTypeEnum, RequestFilterValueTypeEnums, mapReactMUIToFilterOperationTypes, mapReactFilterValueTypeToRequestFilterValueType } from '../../../common/enums/RequestFilterEnums';
import { Loading } from '../../../components';
import MoreVertOutlined from '@mui/icons-material/MoreVertOutlined';
import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';
import { months, monthFilterOperator, MonthFilter } from '../../../components/atoms/grid-filter-operations';
import BaseFilterTableWithAccordion from '../../../components/atoms/BaseFilterTableWithAccordion';
import * as zod from 'zod';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Button } from "../../atoms";

const currentYear = new Date().getFullYear();
const startYear = 2000;
const years = [];

for (let year = currentYear; year >= startYear; year--) {
    years.push({ name: year.toString(), value: year });
}

const MerchantMonthlyTransactionAmountComponentRequestSchema = zod.object({
    merchantName: zod.any(),
    merchantId: zod.any(),
    selectedYear: zod.any(),
    currency: zod.any()
});

type MerchantMonthlyTransactionAmountComponentFormRequest = zod.infer<
    typeof MerchantMonthlyTransactionAmountComponentRequestSchema
>;

const MerchantMonthlyTransactionAmountComponentFormRequestInitValues: MerchantMonthlyTransactionAmountComponentFormRequest =
{
    merchantName: null,
    merchantId: null,
    currency: null,
    selectedYear: null
};

export const MerchantMonthlyTransactionAmountComponent = ({ merchant }: any) => {
    const theme = useTheme();
    const { showDelete, showUpdate, showCreate } = useAuthorization();
    const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
    const [showTable, setShowTable] = useState(false)
    const [modalMode, setModalMode] = useState<'insert' | 'update'>('insert');
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [isTableSubmitted, setIsTableSubmitted] = useState(false);

    const { mutate: getMerchantMonthlyTransactionAmount, isLoading: isGetMerchantMonthlyTransactionAmountLoading } = useGetMerchantMonthlyTransactionAmount();
    const { data: rawMerchantList, isLoading: isGetAllMerchantListLoading } = useGetAllMerchantList("ACTIVE");
    const { data: rawCurrencyList, isLoading: isCurrencyListLoading } = useGetCurrencyCodeList({
        page: 0,
        size: 100,
        orderByDesc: true,
        orderBy: "CreateDate",
        status: "ACTIVE"
    });

    var isPageLoading = isGetMerchantMonthlyTransactionAmountLoading ||
        isGetAllMerchantListLoading ||
        isCurrencyListLoading;

    const { control, handleSubmit, setValue, getValues } =
        useForm<MerchantMonthlyTransactionAmountComponentFormRequest>({
            resolver: zodResolver(MerchantMonthlyTransactionAmountComponentRequestSchema),
            defaultValues: MerchantMonthlyTransactionAmountComponentFormRequestInitValues,
        });

    const setSnackbar = useSetSnackBar();


    const merchantList = useMemo(() => {
        return rawMerchantList?.data?.map(
            (rawPosType: { merchantName: string; merchantId: number }) => {
                return {
                    label: `${rawPosType.merchantName} (${rawPosType.merchantId})`,
                    value: rawPosType.merchantId,
                };
            }
        );
    }, [rawMerchantList?.data]);

    const currencyCodeList = useMemo(() => {
        return rawCurrencyList?.data?.map(
            (currencyCode: { value: string; key: string }) => {
                return {
                    label: `${currencyCode.value}`,
                    value: currencyCode.key,
                };
            }
        );
    }, [rawCurrencyList?.data]);

    interface QueryOptions {
        field?: string;
        value?: any;
        clearFilter?: boolean;
        [key: string]: string | number | boolean | undefined | any;
    }

    const [queryOptions, setQueryOptions] = React.useState<QueryOptions>({});
    const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
        page: 0,
        pageSize: 25,
    });

    const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const location = useLocation();
    const [dynamicFilters, setDynamicFilter] = useState<any>([]);

    useEffect(() => {
        let payload: GetMerchantMonthlyTransactionAmountRequest = {
            page: paginationModel.page,
            size: paginationModel.pageSize,
            year: (getValues('selectedYear')?.length > 0 ?? 0) ? parseInt(getValues('selectedYear')[0]) : dayjs().year(),
        };

        if ((getValues('currency')?.length > 0 ?? false)) {
            payload.currency = getValues('currency')[0];
        }

        if ((getValues('merchantId')?.length > 0 ?? false)) {
            let findMerchant = rawMerchantList?.data.find(x => x.merchantId == getValues('merchantId')[0])?.merchantName;
            if (findMerchant) {
                payload.merchantName = findMerchant;
            }
        }

        getMerchantMonthlyTransactionAmount(payload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    setTableData(data.data);
                } else {
                    setTableData({});
                    setSnackbar({
                        severity: "error",
                        description: "Bir hata oluştu.",
                        isOpen: true,
                    });
                }
            },
            onError: (error) => {
                setTableData({});
                setSnackbar({
                    severity: "error",
                    description: error.message || "Bir hata oluştu.",
                    isOpen: true,
                });
            }
        });
    }, [paginationModel, queryOptions, dynamicFilters, isTableSubmitted]);

    const debounce = (func: (...args: any[]) => void, delay: number) => {
        let timeoutId: NodeJS.Timeout;
        return (...args: any[]) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    interface FilterParams {
        [key: string]: string | number | boolean | null | undefined;
    }

    const getQueryParams = (filters: FilterParams) => {
        const queryParams: { [key: string]: string | number | boolean } = {};

        for (let key in filters) {
            let value = filters[key];
            // Eğer gelen değer string "false" ise onu boolean false'a çevir
            if (value === "false") {
                queryParams[key] = false;
            } else {
                if (value !== null && value !== undefined && value.toString().length > 0) {
                    queryParams[key] = value;
                }
            }
        }
        return queryParams;
    };

    const handleFilterChange = debounce((filters, tableFilters) => {
        if (filters.clearFilter) {
            setDynamicFilter([]);
            return setQueryOptions({});
        }
        const queryParams = getQueryParams(filters);

        const isValueValid = (key: string, value: any): boolean => {
            if (key === 'installmentCount' || key === 'cardType' || key === 'selectedMonth' || key === 'totalCount' || key === 'totalChargeAmount') { // Özel alan kontrolü
                return value?.toString().length >= 1;
            } else {
                return value?.toString().length >= 3;
            }
        }

        const allValuesValid = Object.entries(queryParams).every(([key, value]) => isValueValid(key, value));
        const previousKeysLength = Object.keys(previousQueryParams.current).length;
        const currentKeysLength = Object.keys(queryParams).length;

        if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
            return;
        }

        if (allValuesValid || (previousKeysLength > currentKeysLength)) {
            setQueryOptions(queryParams);
            setDynamicFilter(convertTableFiltersToRequestFilter(tableFilters));
        }


        // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
        previousQueryParams.current = queryParams;

    }, 500);
    const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
    // Komponent içerisinde
    const previousQueryParams = React.useRef({});

    const [menuAnchorEl, setMenuAnchorEl] = useState<{ [key: string]: HTMLElement | null }>({});

    const booleanOptions = [
        { label: "Evet", value: true },
        { label: "Hayır", value: "false" },
    ];

    const columns: GridColDefExt[] = useMemo(() => {
        return [
            { field: 'companyTitle', headerName: 'Üye İşyeri Adı', width: 250, columnType: RequestFilterValueTypeEnums.STRING },
            { field: 'january', headerName: 'Ocak', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'february', headerName: 'Şubat', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'march', headerName: 'Mart', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'april', headerName: 'Nisan', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'may', headerName: 'Mayıs', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'june', headerName: 'Haziran', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'july', headerName: 'Temmuz', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'august', headerName: 'Ağustos', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'september', headerName: 'Eylül', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'october', headerName: 'Ekim', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'november', headerName: 'Kasım', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
            { field: 'december', headerName: 'Aralık', width: 150, columnType: RequestFilterValueTypeEnums.NUMBER, type: 'decimal', filterable: false, sortable: false },
        ];
    }, [menuAnchorEl, showUpdate, showDelete]);

    const convertTableFiltersToRequestFilter = (tableFilters: any) => {

        let convertedFilters: any = [];

        tableFilters.items.map((item: any) => {

            var findColumn = columns.find(x => x.field == item.field);

            convertedFilters.push({
                field: item.field,
                values: [item.value.toString()],
                valueType: mapReactFilterValueTypeToRequestFilterValueType(item.value, findColumn?.columnType),
                operationType: mapReactMUIToFilterOperationTypes(item.operator)
            });
        });

        return convertedFilters;
    }

    const handleChangePagination = (model: GridPaginationModel) => {
        setPaginationModel(model);
    };

    function fieldValue(data: any[]): Record<string, string | number | boolean | undefined>[] {
        let tempCurrency = rawCurrencyList?.data;
        return data.map((item) => {
            return {
                'Üye İşyeri Adı': item?.companyTitle,
                'Para Birimi': tempCurrency.find(x => x.key == item?.currency)?.value || item?.currency || '',
                'Ocak': item?.january,
                'Şubat': item?.february,
                'Mart': item?.march,
                'Nisan': item?.april,
                'Mayıs': item?.may,
                'Haziran': item?.june,
                'Temmuz': item?.july,
                'Ağustos': item?.august,
                'Eylül': item?.september,
                'Ekim': item?.october,
                'Kasım': item?.november,
                'Aralık': item?.december
            };
        });
    }
    const onSave = () => {

        let payload: GetMerchantMonthlyTransactionAmountRequest = {
            page: 0,
            size: tableData?.totalItems || 0,
            year: (getValues('selectedYear')?.length > 0 ?? 0) ? parseInt(getValues('selectedYear')[0]) : dayjs().year(),
        };

        if ((getValues('currency')?.length > 0 ?? false)) {
            payload.currency = getValues('currency')[0];
        }

        if ((getValues('merchantId')?.length > 0 ?? false)) {
            let findMerchant = rawMerchantList?.data.find(x => x.merchantId == getValues('merchantId')[0])?.merchantName;
            if (findMerchant) {
                payload.merchantName = findMerchant;
            }
        }

        getMerchantMonthlyTransactionAmount(payload, {
            onSuccess: (data) => {
                if (data.isSuccess) {
                    const refactoredData = fieldValue(data?.data?.result);
                    downloadExcel(refactoredData || [], "üye-işyeri-aylık-işlem-tutarı");
                } else {
                    setSnackbar({
                        severity: "error",
                        description: "Bir hata oluştu.",
                        isOpen: true,
                    });
                }
            },
            onError: (error) => {
                setSnackbar({
                    severity: "error",
                    description: error.message || "Bir hata oluştu.",
                    isOpen: true,
                });
            }
        });
    };


    const onSubmit = (data: MerchantMonthlyTransactionAmountComponentFormRequest) => {
        console.log('data', data);
        setFilterAccordionExpand(false);
        setTableData(undefined);
        setShowTable(true);
        let newFilter = [...dynamicFilters];

        if (data.merchantId && data.merchantId.length > 0) {
            if (newFilter.find((filter: any) => filter.field === 'merchantId')) {
                newFilter.find((filter: any) => filter.field === 'merchantId').values = data.merchantId ? data.merchantId.map((item: any) => item.toString()) : [];
            } else {
                newFilter.push({
                    field: 'merchantId',
                    values: data.merchantId ? data.merchantId.map((item: any) => item.toString()) : [],
                    valueType: RequestFilterValueTypeEnums.NUMBER,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'merchantId');
        }


        if (data.selectedYear && data.selectedYear.length > 0) {
            if (newFilter.find((filter: any) => filter.field === 'selectedYear')) {
                newFilter.find((filter: any) => filter.field === 'selectedYear').values = data.selectedYear ? data.selectedYear.map((item: any) => item.toString()) : [];
            } else {
                newFilter.push({
                    field: 'selectedYear',
                    values: data.selectedYear ? data.selectedYear.map((item: any) => item.toString()) : [],
                    valueType: RequestFilterValueTypeEnums.NUMBER,
                    operationType: RequestFilterOperationTypeEnum.CONTIANS
                });
            }
        } else {
            newFilter = newFilter.filter((filter: any) => filter.field !== 'selectedYear');
        }

        setDynamicFilter(newFilter);
    }

    return (

        <ThemeProvider theme={theme}>
            {isPageLoading && <Loading />}
            <Box className="p-4" sx={{ p: 2 }}>

                <BaseFilterTableWithAccordion
                    isExpanded={isFilterAccordionExpanded}
                    setExpanded={setFilterAccordionExpand}
                    setTableVisibility={setShowTable}
                    child={<Stack spacing={4}>
                        <Stack
                            spacing={3}
                            direction={isDesktop ? "row" : "column"}
                            width={'100%'}
                        >
                            <FormControl sx={{ flex: 1 }}>
                                {merchantList && (
                                    <Controller
                                        control={control}
                                        name="merchantId"
                                        render={({ field }) => (
                                            <Autocomplete
                                                id="merchant-single-select"
                                                options={merchantList}
                                                getOptionLabel={(option) => option.label}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? [newValue.value] : []);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Üye İşyeri" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                {currencyCodeList && (
                                    <Controller
                                        control={control}
                                        name="currency"
                                        render={({ field }) => (
                                            <Autocomplete
                                                id="month-single-select"
                                                options={currencyCodeList}
                                                getOptionLabel={(option) => option.label}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? [newValue.value] : []);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Para Birimi" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <FormControl sx={{ flex: 1 }}>
                                {years && (
                                    <Controller
                                        control={control}
                                        name="selectedYear"
                                        render={({ field }) => (
                                            <Autocomplete
                                                id="year-single-select"
                                                options={years}
                                                getOptionLabel={(option) => option.name}
                                                onChange={(event, newValue) => {
                                                    field.onChange(newValue ? [newValue.value] : []);
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Yıl" placeholder="Seçiniz" />
                                                )}
                                            />
                                        )}
                                    />
                                )}
                            </FormControl>
                            <Button
                                onClick={handleSubmit(onSubmit)}
                                variant="contained"
                                text={"ARA"}
                            />
                        </Stack>
                    </Stack>}
                    summary={'Filtre yönetimi'}
                ></BaseFilterTableWithAccordion>

                <Box sx={{ mt: 2 }}>
                    {(tableData && showTable) && <Table
                        filterKey="merchantPOSUsageFeeFilterKey"
                        columnVisibilityConfigKey="merchantPOSUsageFeeFilterColumnVisibilityKey"
                        hasActiveFilters={hasActiveFilters}
                        handleFilterChange={handleFilterChange}
                        paginationModel={paginationModel}
                        onPaginationModelChange={handleChangePagination}
                        paginationMode="server"
                        rowCount={tableData?.totalItems || 0}
                        isRowSelectable={() => false}
                        customLabelDisplayedRows={true}
                        autoHeight={false}
                        getRowId={() => { return Math.floor(Math.random() * 100000) }}
                        rows={tableData?.result || []}
                        columns={columns}
                        getRowClassName={(params: { row: { status: string } }) => {
                            if (params.row.status === "PASSIVE") return "blocked-row";
                            if (params.row.status === "BLOCKED") return "pasive-row";
                            return "";
                        }}
                        exportFileName="Üye İşyeri POS Kullanım Bedeli Raporu"
                        onSave={onSave}
                    />}
                </Box>
            </Box>
        </ThemeProvider>
    );
};